const CellTDStartEndTime: React.FC<{ data: any }> = ({ data }) => {

    return (
        <><small>Start: {data['start_time']}</small><br /><small>End: {data['end_time']}</small></>
    )
}

export default CellTDStartEndTime;